import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";

const INITIAL_STATE = {
    messages: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const chatreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MESSAGES:
            return {
                ...state,
                loading: true,
                currentBookingId: action.payload,
                messages: state.currentBookingId === action.payload ? (state.messages || []) : (state.messages || [])
            };
        case FETCH_MESSAGES_SUCCESS:
            return {
                ...state,
                messages: action.payload,
                loading: false,
                error: {
                    flag: false,
                    msg: null
                }
            };
        case FETCH_MESSAGES_FAILED:
            return {
                ...state,
                messages: (state.messages && state.messages.length > 0) ? state.messages : [],
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case SEND_MESSAGE: {
            const current = state.messages || [];
            const exists = current.some(m => m.smsId && action.payload && m.smsId === action.payload.smsId);
            return {
                ...state,
                messages: exists ? current : [...current, action.payload]
            };
        }
        case STOP_FETCH_MESSAGES:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};